import React, { useState } from 'react';
import {
  CurrencyDollarIcon,
  ExclamationCircleIcon,
} from '@heroicons/react/solid';
import { isUrlValid } from '../../../Functions/utlities';
import {
  create_unsigned_app_call,
  create_unsigned_pymnt_txn,
  create_signed_txn_group,
  send_txn,
} from '../../../Functions/operations';
import { useAppSelector } from '../../../hooks';
import { useAppDispatch } from '../../../hooks';
import { updateDepositStepPassed } from '../../../reducer';

const app_id = 55273383;

export default function PayDeposit() {
  const address = useAppSelector((state) => state.subscription.optedInAddress);
  const dispatch = useAppDispatch();

  const [urlError, setUrlError] = useState(false);
  const [url, setUrl] = useState('');
  const [confirmed, setConfirmed] = useState(false);
  const [error, setError] = useState({ error: false, message: '' });
  const errorStyle =
    'border-red-300 focus:ring-red-500 focus:border-red-500 text-red-900 placeholder-red-300';
  const normalStyle = 'border-gray-300';

  const updateUrl = (e: any) => {
    if (isUrlValid(e.target.value)) {
      setUrlError(false);
      setUrl(e.target.value);
    } else {
      setUrlError(true);
      setUrl(e.target.value);
    }
  };

  // function unpack(str: string) {
  //   const bytes = [];
  //   for (let i = 0; i < str.length; i++) {
  //     const char = str.charCodeAt(i);
  //     bytes.push(char >>> 8);
  //     bytes.push(char & 0xff);
  //   }
  //   return bytes;
  // }

  const handlePayment = async () => {
    try {
      if (isUrlValid(url)) {
        setUrlError(false);
        // build payment txn
        const unsigned_pymnt_txn = await create_unsigned_pymnt_txn(
          address,
          app_id,
          undefined
        );
        const utf8Enconde = new TextEncoder();
        const unsigned_app_call = await create_unsigned_app_call(
          address,
          [utf8Enconde.encode('deposit'), utf8Enconde.encode(url)],
          app_id
        );
        const signed_txn_group = await create_signed_txn_group([
          unsigned_pymnt_txn,
          unsigned_app_call,
        ]);
        const txn_id = await send_txn(signed_txn_group);
        console.log(txn_id);

        dispatch(updateDepositStepPassed(true));
        setError({ error: false, message: '' });
        setConfirmed(true);
      } else {
        setUrlError(true);
      }
    } catch (error) {
      console.error('HANDLE PAYMENT ERROR:::', error);
      setError({
        error: true,
        message:
          'An error has occurred. Try again later, or contact info@goracle.io',
      });
    }
  };

  return (
    <div style={{ minHeight: '35em' }}>
      <div className="container w-full mx-auto overflow-hidden">
        <p className="mt-5 text-lg  max-w-3xl text-gray-900">
          Enter your URL below. Ensure you have read the Goracle documentation
          on how endpoints should be configured to respond.
        </p>
        <div className="mt-10 w-96">
          <label
            htmlFor="email"
            className="block text-sm font-medium text-gray-700"
          >
            URL
          </label>
          <div className="mt-1 relative rounded-md shadow-sm">
            <input
              type="email"
              name="email"
              id="email"
              onChange={updateUrl}
              className={`block w-full pr-10 ${
                urlError ? errorStyle : normalStyle
              }  focus:outline-none  sm:text-sm rounded-md`}
              placeholder="https://"
              defaultValue="https://"
              aria-invalid="true"
              aria-describedby="email-error"
            />
            {urlError && (
              <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                <ExclamationCircleIcon
                  className="h-5 w-5 text-red-500"
                  aria-hidden="true"
                />
              </div>
            )}
          </div>
          {urlError && (
            <p className="mt-2 text-sm text-red-600" id="email-error">
              Must be Valid URL format
            </p>
          )}
          {error.error && (
            <p className="text-red-500 italic text-sm"> {error.message} </p>
          )}
          {
            <h3 className={`my-1 ${!confirmed && 'invisible'} text-green-700`}>
              Success!
            </h3>
          }
        </div>
        <button
          onClick={handlePayment}
          type="button"
          className=" my-10 inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          Pay Deposit
          <CurrencyDollarIcon
            className="ml-2 -mr-1 h-5 w-5"
            aria-hidden="true"
          />
        </button>
      </div>
    </div>
  );
}
